import React from 'react'

interface Props {
  children: React.ReactNode
  onClick: () => void
  className?: string
}

export const CustomButton: React.FC<Props> = ({onClick, children, className}) => {
  return (
    <button
      id='btn_custom_button'
      className={className ? className : 'btn btn-sm btn-link text-primary-active'}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default CustomButton
